<template>
  <div>
    <component :is="current" :style="cssVars" />
  </div>
</template>

<script>
  export default {
    name: 'DefaultAvatar',
    components: {
      'initialA': () => import('~/assets/avatars/avatar-initials-a.svg?inline'),
      'initialB': () => import('~/assets/avatars/avatar-initials-b.svg?inline'),
      'initialC': () => import('~/assets/avatars/avatar-initials-c.svg?inline'),
      'initialD': () => import('~/assets/avatars/avatar-initials-d.svg?inline'),
      'initialE': () => import('~/assets/avatars/avatar-initials-e.svg?inline'),
      'initialF': () => import('~/assets/avatars/avatar-initials-f.svg?inline'),
      'initialG': () => import('~/assets/avatars/avatar-initials-g.svg?inline'),
      'initialH': () => import('~/assets/avatars/avatar-initials-h.svg?inline'),
      'initialI': () => import('~/assets/avatars/avatar-initials-i.svg?inline'),
      'initialJ': () => import('~/assets/avatars/avatar-initials-j.svg?inline'),
      'initialK': () => import('~/assets/avatars/avatar-initials-k.svg?inline'),
      'initialL': () => import('~/assets/avatars/avatar-initials-l.svg?inline'),
      'initialM': () => import('~/assets/avatars/avatar-initials-m.svg?inline'),
      'initialN': () => import('~/assets/avatars/avatar-initials-n.svg?inline'),
      'initialO': () => import('~/assets/avatars/avatar-initials-o.svg?inline'),
      'initialP': () => import('~/assets/avatars/avatar-initials-p.svg?inline'),
      'initialQ': () => import('~/assets/avatars/avatar-initials-q.svg?inline'),
      'initialR': () => import('~/assets/avatars/avatar-initials-r.svg?inline'),
      'initialS': () => import('~/assets/avatars/avatar-initials-s.svg?inline'),
      'initialT': () => import('~/assets/avatars/avatar-initials-t.svg?inline'),
      'initialU': () => import('~/assets/avatars/avatar-initials-u.svg?inline'),
      'initialV': () => import('~/assets/avatars/avatar-initials-v.svg?inline'),
      'initialW': () => import('~/assets/avatars/avatar-initials-w.svg?inline'),
      'initialX': () => import('~/assets/avatars/avatar-initials-x.svg?inline'),
      'initialY': () => import('~/assets/avatars/avatar-initials-y.svg?inline'),
      'initialZ': () => import('~/assets/avatars/avatar-initials-z.svg?inline'),
      'initialLwc': () => import('~/assets/avatars/avatar-initials-lwc.svg?inline'),
    },
    props: {
      initial: {
        type: String,
      }
    },
    data () {
      return {
        current: (/[a-zA-Z]/).test(this.initial)
          ? 'initial'+this.initial.toUpperCase()
          : 'initialLwc'
      }
    },
    computed: {
      cssVars() {
        let colours = [
          ['#e6dab9', '#f87d0a'], // magnolia-dark, orange
          ['#699c9a', '#ffffff'], // green, white
          ['#f87d0a', '#ffffff'], // orange, white
          ['#351161', '#ffffff'], // purple, white
        ]

        let selectedColours = colours[Math.floor(Math.random() * colours.length)]

        return {
          '--bg-color': selectedColours[0],
          '--letter-color': selectedColours[1]
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .default-avatar {
    width: 100%;
    vertical-align: middle;

    /deep/ .cls-1 {
      fill: var(--letter-color);
    }

    /deep/ .cls-2 {
      fill: var(--bg-color);
    }
  }
</style>
